"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdditionalContentNode = void 0;
const react_dom_1 = require("react-dom");
const getAdditionalContentNode = (menuItemsRef) => {
    var _a, _b;
    return (_b = (_a = menuItemsRef.current) === null || _a === void 0 ? void 0 : _a.map((nodeRef) => 
    // eslint-disable-next-line react/no-find-dom-node
    (0, react_dom_1.findDOMNode)(nodeRef.current))) !== null && _b !== void 0 ? _b : [];
};
exports.getAdditionalContentNode = getAdditionalContentNode;
//# sourceMappingURL=getAdditionalContentNode.js.map